import {
  auditsController,
  dealersController
} from '@cdab/scania/qpr/offline/controllers'
import { capitalizeFirstLetter } from '@cdab/utils'
import { TdsToast } from '@scania/tegel-react'
import { observer } from 'mobx-react-lite'
import { forwardRef, useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import type { EditAuditModalProps, ParsedAuditData } from './audit-modal.types'
import { AuditModal } from './common-audit-modal'

export const AuditEditModal = observer(
  forwardRef<HTMLTdsModalElement, EditAuditModalProps>(function AuditEditModal(
    props,
    ref
  ) {
    const [disableSave, setDisableSave] = useState(false)
    const { audit, onClose } = props
    const [t] = useTranslation('common')

    const handleSubmit = useCallback(
      async (data: ParsedAuditData) => {
        setDisableSave(true)
        await auditsController.UpdateAudit(audit, {
          date: data.date,
          description: data.description ?? '',
          extraAuditors: data.extraAuditor ?? '',
          auditTypeId: data.auditTypeId
        })
        toast(
          <TdsToast
            variant='success'
            header={capitalizeFirstLetter(t('audit-updated', { ns: 'common' }))}
            subheader={capitalizeFirstLetter(
              t('audit-updated-success', { ns: 'common' })
            )}
          />
        )
        dealersController.GetDealer(audit.did) // GetDealer is used here so UpdateAudit endpoint could update dealer date
        setDisableSave(false)
        return true
      },
      [audit, t]
    )

    return (
      <AuditModal
        ref={ref}
        header={t('edit-audit')}
        initialDate={audit.date}
        initialDescription={audit.description ?? undefined}
        initialExtraAuditor={audit.extraAuditors}
        onSubmit={handleSubmit}
        onClose={onClose}
        initialAuditTypeId={audit.auditTypeId}
        disableSave={disableSave}
      />
    )
  })
)
